import script from "./CustomersView.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomersView.vue?vue&type=script&setup=true&lang=js"

import "./CustomersView.vue?vue&type=style&index=0&id=06cdcd58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06cdcd58"]])

export default __exports__